// ABOUTME: Browser tab title for a route, built from the sidebar and hub-tab labels
// ABOUTME: Symbol routes lead with the ticker; unknown routes get the bare app name

import {
  DISCOVER_TABS,
  MARKET_TABS,
  RISK_TABS,
  STRATEGY_TABS,
  TRADE_TABS,
} from '../components/hubs';
import { helpItems, navGroups } from '../components/sidebar-nav';

const APP_NAME = 'Alpha Finder';

// Hub tabs first: a hub's menu entry shares its first tab's path but names the hub.
const LABELLED_PATHS: { path: string; label: string }[] = [
  ...[DISCOVER_TABS, TRADE_TABS, RISK_TABS, STRATEGY_TABS, MARKET_TABS].flat(),
  ...navGroups.flatMap((g) => g.items),
  ...helpItems,
  { path: '/dashboard', label: 'Dashboard' },
  { path: '/settings', label: 'Settings' },
];

const SYMBOL_ROUTES: { prefix: string; suffix: string }[] = [
  { prefix: '/symbol/', suffix: '' },
  { prefix: '/forecast/', suffix: ' Forecast' },
  { prefix: '/entry-positions/', suffix: ' Entry Positions' },
];

export function pageTitle(pathname: string): string {
  for (const { prefix, suffix } of SYMBOL_ROUTES) {
    const symbol = pathname.startsWith(prefix) ? pathname.slice(prefix.length) : '';
    if (symbol && !symbol.includes('/')) {
      return `${decodeURIComponent(symbol).toUpperCase()}${suffix} · ${APP_NAME}`;
    }
  }
  const exact = LABELLED_PATHS.find((p) => p.path === pathname);
  const section = LABELLED_PATHS.find((p) => p.path !== '/' && pathname.startsWith(`${p.path}/`));
  const label = (exact ?? section)?.label;
  return label ? `${label} · ${APP_NAME}` : APP_NAME;
}
